import { put, call, take, select, fork } from 'redux-saga/effects'
import { showNotification } from '../../../app/actions'
import { actionNames } from './actions'
import { fetchTimeZones } from './api'

const getTimeZones = (state) => state.timezones

function* fetchTimeZonesWorker() {
  try {
    const { timezones } = yield call(fetchTimeZones)
    yield put({
      type: actionNames.FETCH_TIMEZONES_SUCCESS,
      timezones,
    })
  } catch (err) {
    yield put({ type: actionNames.FETCH_TIMEZONES_FAILURE })
    yield put(
      showNotification({
        type: 'error',
        message: 'Timezones data could not be loaded.',
      })
    )
  }
}

function* watchFetch() {
  yield take(actionNames.FETCH_TIMEZONES)

  const timeZones = yield select(getTimeZones)
  if (timeZones.length > 0) {
    yield put({ type: actionNames.FETCH_TIMEZONES_LOADED })
    return
  }

  yield fork(fetchTimeZonesWorker)
}

export default [watchFetch]

export { watchFetch }
